/* beautiful-react-hooks version: 0.25.5 */
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var safelyParseJson = function safelyParseJson(parseString) {
  try {
    return JSON.parse(parseString);
  } catch (e) {
    return null;
  }
};

exports.default = safelyParseJson;